<div class="email-designer-container">
  <!-- Loading State -->
  <div class="loading-overlay" *ngIf="loading">
    <kendo-loader type="infinite-spinner" size="large"></kendo-loader>
  </div>

  <!-- Header -->
  <div class="designer-header">
    <div class="header-left">
      <button kendoButton fillMode="flat" (click)="cancel()">
        <span class="k-icon k-font-icon k-i-arrow-left"></span> Back to Templates
      </button>
      <h2>{{ isNew ? 'Create New Template' : 'Edit Template' }}</h2>
    </div>
    <div class="header-right">
      <button kendoButton fillMode="outline" (click)="preview()" [disabled]="saving">
        <span class="k-icon k-font-icon k-i-preview"></span> Preview
      </button>
      <button kendoButton fillMode="outline" (click)="sendTestEmail()" [disabled]="saving">
        <span class="k-icon k-font-icon k-i-email"></span> Send Test
      </button>
      <button kendoButton themeColor="primary" (click)="save()" [disabled]="saving">
        <span class="k-icon k-font-icon k-i-save"></span> {{ saving ? 'Saving...' : 'Save Template' }}
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <div class="designer-content">
    <!-- Sidebar - Template Settings -->
    <div class="settings-sidebar">
      <div class="settings-panel">
        <h3>Template Settings</h3>

        <div class="form-group">
          <label>Template Name *</label>
          <kendo-textbox 
            [(ngModel)]="templateName" 
            placeholder="Enter template name"
            [maxlength]="100">
          </kendo-textbox>
        </div>

        <div class="form-group">
          <label>Event Type *</label>
          <kendo-dropdownlist
            [(ngModel)]="templateEventType"
            [data]="eventTypes"
            [valuePrimitive]="true"
            [defaultItem]="'Select event type...'"
          ></kendo-dropdownlist>
        </div>

        <div class="form-group">
          <label>Subject *</label>
          <kendo-textbox 
            [(ngModel)]="templateSubject" 
            placeholder="Email subject line"
            [maxlength]="500">
          </kendo-textbox>
          <div class="subject-hint">
            Use <code ngNonBindable>{{VariableName}}</code> to insert dynamic content
          </div>
        </div>

        <div class="form-group">
          <label>Status</label>
          <kendo-switch [(ngModel)]="isActive"></kendo-switch>
          <span class="status-label">{{ isActive ? 'Active' : 'Inactive' }}</span>
        </div>
      </div>

      <!-- Variables Panel -->
      <div class="settings-panel variables-panel" *ngIf="templateEventType">
        <h3>Available Variables</h3>
        <p class="panel-hint">Click to copy variable to clipboard</p>
        <div class="variables-list">
          <button 
            *ngFor="let variable of getVariablesForEventType()"
            class="variable-chip"
            (click)="insertVariable(variable)"
            title="Click to insert"
          >
            <code ngNonBindable>&#123;&#123;</code>{{ variable }}<code ngNonBindable>&#125;&#125;</code>
          </button>
        </div>
      </div>

      <!-- Template Type Selector -->
      <div class="settings-panel">
        <h3>Template Type</h3>
        <div class="template-type-options">
          <button 
            kendoButton 
            [fillMode]="selectedTemplateType === 'designer' ? 'solid' : 'outline'"
            [themeColor]="selectedTemplateType === 'designer' ? 'primary' : 'base'"
            (click)="onTemplateTypeChange('designer')"
            class="type-btn"
          >
            <span class="k-icon k-font-icon k-i-image-edit"></span>
            Drag & Drop
          </button>
          <button 
            kendoButton 
            [fillMode]="selectedTemplateType === 'html' ? 'solid' : 'outline'"
            [themeColor]="selectedTemplateType === 'html' ? 'primary' : 'base'"
            (click)="onTemplateTypeChange('html')"
            class="type-btn"
          >
            <span class="k-icon k-font-icon k-i-html"></span>
            HTML Code
          </button>
          <button 
            kendoButton 
            [fillMode]="selectedTemplateType === 'text' ? 'solid' : 'outline'"
            [themeColor]="selectedTemplateType === 'text' ? 'primary' : 'base'"
            (click)="onTemplateTypeChange('text')"
            class="type-btn"
          >
            <span class="k-icon k-font-icon k-i-text"></span>
            Plain Text
          </button>
        </div>
      </div>
    </div>

    <!-- Editor Area -->
    <div class="editor-area">
      <!-- Drag and Drop Designer -->
      <div class="designer-wrapper" *ngIf="selectedTemplateType === 'designer'">
        <lib-email-designer 
          #emailEditor 
          class="email-designer-instance"
          [type]="selectedTemplateType" 
          [template]="selectedTemplate"
          (imageSelectionTriggered)="onImageSelectionTrigger($event)"
          (imageUploadTriggered)="onImageUploadTrigger($event)"
          (emailContentChanged)="onEmailContentChange($event)"
        >
        </lib-email-designer>
      </div>

      <!-- HTML Editor -->
      <div class="html-editor-wrapper" *ngIf="selectedTemplateType === 'html'">
        <div class="editor-toolbar">
          <span class="toolbar-label">HTML Editor</span>
          <button kendoButton size="small" fillMode="flat" (click)="preview()">
            <span class="k-icon k-font-icon k-i-preview"></span> Preview
          </button>
        </div>
        <kendo-editor
          [(ngModel)]="selectedTemplate"
          [iframe]="true"
          style="height: 100%;"
        >
        </kendo-editor>
      </div>

      <!-- Plain Text Editor -->
      <div class="text-editor-wrapper" *ngIf="selectedTemplateType === 'text'">
        <div class="editor-toolbar">
          <span class="toolbar-label">Plain Text Editor</span>
        </div>
        <kendo-textarea
          [(ngModel)]="selectedTemplate"
          [rows]="30"
          placeholder="Enter your plain text email content here..."
          class="text-editor"
        ></kendo-textarea>
      </div>
    </div>
  </div>
</div>
